<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-proportion`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c12.15 0 22 9.85 22 22s-9.85 22-22 22S2 36.15 2 24 11.85 2 24 2zm-.31 22.425L11.369 36.824A17.942 17.942 0 0024 42c4.764 0 9.095-1.85 12.315-4.872L23.69 24.425zM6 24c0-9.941 8.059-18 18-18s18 8.059 18 18c0 3.733-1.136 7.2-3.081 10.075L25.825 20.899l-.14-.133a2.983 2.983 0 00-4.13.133l-12.72 12.8A17.916 17.916 0 016 24z"/></svg>
</template>
<script>

export default {
  name: 'IconProportion',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
